var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"value":_vm.content,"init":_vm.editorOptions,"apiKey":"1f4dburbo223re9wxcocxgqhrueu0424ae4dnnfm6b8m4mgj"},on:{"onChange":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }